var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#F7B500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1094 17H9.89062V8.54688H12.1094V17ZM9.78906 6.35938C9.78906 6.01562 9.89844 5.73438 10.1172 5.51562C10.3359 5.29688 10.6276 5.1875 10.9922 5.1875C11.3568 5.1875 11.6484 5.29688 11.8672 5.51562C12.0859 5.73438 12.1953 6.01562 12.1953 6.35938C12.1953 6.69792 12.0859 6.97917 11.8672 7.20312C11.6536 7.42708 11.362 7.53906 10.9922 7.53906C10.6224 7.53906 10.3281 7.42708 10.1094 7.20312C9.89583 6.97917 9.78906 6.69792 9.78906 6.35938Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e026016f5defb2a6195f144203b17536.svg";
export { ForwardRef as ReactComponent };